import Index from '@tunnel-components/@pages/administration/home/container'


/**
 * @export Container
 */

export default Index


// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@pages/administration/home/index.ts